import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import ComponentHeader from "../Header/ComponentHeader";
import DoubleBar from "../Elements/DoubleBar";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import {
  mainColor,
  oppositeColor,
  primaryColor,
  secondaryColor,
  sectionPopulationLocationColor
} from "../../Util/Colors";
import {
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";
import EmptySpace from "../Elements/EmptySpace";
import { valuePairToPercent, isCurrentYear } from "../../Helpers/CommonHelper";
import { useInView } from "react-intersection-observer";

const PopulationLocationContainer = props => {
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });

  const { data, sweden, scroll } = props;

  let valueData = [];
  let valueArr = [];
  let swedenArr, swedenString;
  const lastYear = sweden.populationLocation.year;
  swedenArr = valuePairToPercent(
    sweden.populationLocation,
    ["urban", "countryside"],
    1
  );
  swedenString =
    "I Sverige bor " +
    swedenArr.pstring1 +
    "  procent i tätort och " +
    swedenArr.pstring2 +
    " procent utanför tätort (" +
    lastYear +
    ").";

  data.forEach((item, i) => {
    if (item) {
      valueData.push(valuePairToPercent(item, ["urban", "countryside"], 1));
      valueArr.push(valueData[i].value1);
      valueArr.push(valueData[i].value2);
    }
  });

  let municipality1 = valueData[0];
  let municipality2 = valueData[1];

  const max = Math.max(...valueArr);
  const maxColumnPairIdx = valueArr.indexOf(Math.max(...valueArr));
  const maxIsEven = maxColumnPairIdx % 2 == 0;

  const maxOffset = max;
  const height = 300;
  const width = 100;
  const topSpace = 64;

  let captions = ["Bor i tätort", "Bor på landsbygd"];

  // Accessibility
  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "bor"
        : "bodde"
      : "";

    return municipality
      ? `I ${municipality.name} ${str} ${municipality.pstring1} procent i tätort och ${municipality.pstring2} procent på landsbyggd (år ${municipality.year}).`
      : "";
  };

  const svgAriaLabel = municipality =>
    municipality
      ? `Det här stapeldiagramet gör jämförelser i befolkning mellan tätort och landsbygd i ${municipality.name} kommun.`
      : "";

  return (
    <React.Fragment>
      <BlockLayout background={sectionPopulationLocationColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M58.0833 28.2115H62.7625V23.5323H58.0833V28.2115ZM58.0833 42.2048H62.7625V37.5257H58.0833V42.2048ZM58.0833 56.1473H62.7625V51.4682H58.0833V56.1473ZM5 68.3332V38.109L26.1092 23.0323L47.1667 38.0982V68.3332H32.5192V51.0382H19.6992V68.3332H5ZM52.615 68.3332V35.064L34.295 22.2115V11.6665H75V68.3332H52.615Z" fill="#0F0865"/>
        <path d="M5 68.3331V38.1089L26.1092 23.0322L47.1667 38.0981V68.3331H32.5192V51.0381H19.6992V68.3331H5Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader
          heading={"Så många bor i och utanför tätort"}
          text={swedenString}
        />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality1)}
                    marginBottom="24px"
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <DoubleBar
                    bar1={{
                      color: mainColor,
                      value: `${parseFloat(municipality1.pstring1) === 100 ? '100' : municipality1.pstring1}%`,
                      label: "Bor i tätort",
                      height: inView ? `${municipality1.value1 > 0 ? height * municipality1.value1 / 100 : 0}px` : "0px",
                      lineColor: mainColor
                    }}
                    bar2={{
                      color: mainColor,
                      value: `${parseFloat(municipality1.pstring2) === 100 ? '100' : municipality1.pstring2}%`,
                      label: "Bor på landsbygd",
                      height: inView ? `${municipality1.value2 > 0 ? height * municipality1.value2 / 100 : 0}px` : "0px",
                      lineColor: mainColor
                    }}
                    inView={inView}
                  />
                </div>
              ) : (
                <div> </div>
              )}
              {municipality2 ? (
                <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality2)}
                    marginBottom="24px"
                    color={secondaryColor}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <DoubleBar
                    bar1={{
                      color: oppositeColor,
                      value: `${parseFloat(municipality2.pstring1) === 100 ? '100' : municipality2.pstring1}%`,
                      label: "Bor i tätort",
                      height: inView ? `${municipality2.value1 > 0 ? height * municipality2.value1 / 100 : 0}px` : "0px",
                      lineColor: oppositeColor
                    }}
                    bar2={{
                      color: oppositeColor,
                      value: `${parseFloat(municipality2.pstring2) === 100 ? '100' : municipality2.pstring2}%`,
                      label: "Bor på landsbygd",
                      height: inView ? `${municipality2.value2 > 0 ? height * municipality2.value2 / 100 : 0}px` : "0px",
                      lineColor: oppositeColor
                    }}
                    inView={inView}
                  />
                </div>
              ) : (
                <SvgLayout>
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

PopulationLocationContainer.defaultProps = {
  data: [],
  sweden: {}
};

export default PopulationLocationContainer;
